var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3159 3.90332C10.5742 3.64508 10.9244 3.5 11.2896 3.5C11.6548 3.5 12.0051 3.64508 12.2633 3.90332C12.5216 4.16156 12.6667 4.51182 12.6667 4.87703C12.6667 5.24224 12.5216 5.59249 12.2633 5.85073L6.09655 12.0175L3.82338 12.5858C3.6769 12.6224 3.54423 12.4898 3.58085 12.3433L4.14914 10.0701L10.3159 3.90332Z",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10L6 11",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGray);
export default __webpack_public_path__ + "static/media/edit_gray.7c9897fffd369cf29d97737c565545d3.svg";
export { ForwardRef as ReactComponent };